




















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { $t } from "@/lib/i18nHelpers";
import { printCredits } from "@/lib/moneyHelpers";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";

@Component({ name: "PriceSetupView", components: { BaseForm, BaseConfirm, BaseButton } })
export default class PriceSetupView extends Vue {
  @Prop({ type: Boolean, required: true })
  public readonly show!: boolean;

  @Prop({ type: Array, required: true })
  public readonly priceList!: SubscriptionLevel[];

  @Prop({ type: Array, required: true })
  public readonly packageList!: PaymentPackage[];

  @Prop({ type: String, required: true })
  public readonly levelId!: string;

  @Prop({ type: String, required: true })
  public readonly pricePackageId!: PaymentPackage[];

  @Prop({ type: Boolean, default: false })
  public readonly hideSubscriptionLevelField!: boolean;

  public values: FormValues = {
    levelId: this.levelId,
    pricePackageId: this.pricePackageId,
  };

  public saving: boolean = false;

  public get isFree() {
    return this.values.levelId === "0" && this.values.pricePackageId === "0";
  }

  get fields(): FormFields {
    const subscriptionList = [
      { text: this.isFree ? $t("Available for everyone") : $t("Disable access by subscription"), value: "0" },
    ].concat(
      this.priceList.map((price, index) => {
        const prices = printCredits(price.pricePackage?.amount ?? 0);
        return {
          text: index === this.priceList.length - 1 ? prices : $t("{0} and higher", [prices]),
          value: price.id,
        };
      })
    );

    const packageOptions = [{ text: $t("Disable one-time buy"), value: "0" }].concat(
      this.packageList.map(packageData => ({
        text: printCredits(packageData.amount),
        value: packageData.id,
      }))
    );

    return [
      ...(!this.hideSubscriptionLevelField
        ? [
            {
              name: "levelId",
              label: $t("Access for subscribers"),
              type: "select",
              options: subscriptionList,
            },
          ]
        : []),
      {
        name: "pricePackageId",
        label: $t("One-time buy"),
        type: "select",
        options: packageOptions,
      },
    ];
  }

  @Watch("pricePackageId")
  @Watch("levelId")
  public watchPriceLevelChange() {
    this.values = {
      levelId: this.levelId,
      pricePackageId: this.pricePackageId,
    };
  }

  public onSave() {
    this.saving = true;
    this.$emit(
      "save",
      { packageId: this.values.pricePackageId, levelId: this.values.levelId },
      () => (this.saving = false)
    );
  }

  public onSetFree() {
    this.values = {
      levelId: "0",
      pricePackageId: "0",
    };
  }

  public onClose() {
    this.$emit("close");
    this.watchPriceLevelChange();
  }
}
